
import wx from 'weixin-js-sdk'
import cmBlank from '@/components/cmBlank.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

export default {
components: {
wx,TransferDom,Popup,cmBlank
},
directives: {
TransferDom
},
data(){
return {
blankShow:false,
authPop:false,
userPop:false,
index1:0,
index2:0,
sort:0,
type:2,
list:[
{
cate:[
{
goods:[]
}
]
},
{
cate:[
{
goods:[]
}
]
},
{
cate:[
{
goods:[]
}
]
},
{
cate:[
{
goods:[]
}
]
}
],
popBg:false,
pop:false,
pop2:false,
gid:0,
info:{},
list1:[],
attrIndex:[],
attrId:0,
attrTitle:'',
attrPrice:0.00,
num:1,
cartNum:0,
listStyle:0,
cart:[],
amount:0,
fromData:{
name:'',
phone:'',
address:'',
house_number:'',
remark:'',
goods:'',
type:0,
},

}
},
created() {
this.getList();
this.config();
},
beforeRouteLeave(to, from, next) {
if(to.name == 'maps'){
from.meta.keepAlive = true;
}else{
var key = this.$vnode.key == null ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '') : this.$vnode.key
var cache = this.$vnode.parent.componentInstance.cache
var keys = this.$vnode.parent.componentInstance.keys
console.log(key,cache,keys);
if (cache[key]) {
if (keys.length) {
var index = keys.indexOf(key)
if (index > -1) {
keys.splice(index, 1)
}
}
delete cache[key]
}
}
next();
},
activated(){
console.log('activated',this.$func.getSession('address'));
if(this.$func.getSession('address')){
this.closePop();
this.userPop = true;
let address = JSON.parse(this.$func.getSession('address'));
this.fromData.address = address.poiaddress;
this.fromData.lat = address.latlng.lat;
this.fromData.lng = address.latlng.lng;
this.$func.setSession('address','');
}
},
methods: {
selectLeft(i){
this.index1 = i;
this.index2 = 0;
},
selectTop (i) {
this.index2 = i
},
getList(){
let that = this;
this.$api.getCategoryGoodsAll({type:this.type}).then((res)=>{
that.list = res.data;
})
},
selectAttr(index,i){
this.attrIndex[index] = i;
this.$forceUpdate();
let ids = '';
if(this.info.spec.length > 1){
this.attrIndex.forEach((item1,i)=>{
ids += ((this.info.spec[i].item[item1].id).toString())+'_';
});
ids = ids.substring(0, ids.length - 1);
}else{
ids = (this.info.spec[0].item[this.attrIndex[0]].id).toString();
}
this.info.attr.forEach((item,index)=>{
if(item.spec_item_ids == ids){
this.attrTitle = item.title;
this.attrPrice = item.cost_price;
this.attrId = item.id;
return;
}
});
},
openPop(item){

this.popBg = true;
this.pop = true;
this.num = 1;
this.attrIndex = [0,0];
this.info = item;
this.gid = item.id;
if(item.attr_status > 0 && item.attr.length > 0){
this.selectAttr(0,0);
}else{
this.attrPrice = (item.cost_price > 0 ? item.cost_price : item.price);
this.attrTitle = '';
this.attrId = 0;
}
},
closePop(){
this.popBg = false;
this.pop = false;
this.pop2 = false;
},
input(){



},
sub(){
this.num = Number(this.num);
this.num = this.num > 1 ? this.num-1 : 1;
},
add(){
this.num = Number(this.num);
this.num = this.num+1
},
sub1(i){
let num = Number(this.cart[i].num);
if(num > 1){
this.cart[i].num = num - 1;
}else{
this.cart.splice(i,1);
}
this.countPrice();
},
add1(i){
this.cart[i].num = parseInt(this.cart[i].num) + 1;
this.countPrice();
},
openCart(){
this.popBg = !this.popBg;
this.pop2 = !this.pop2;
},
addCart(){
let that = this;
if(that.num < 0){
that.num = 1;
}
if(this.cart.length > 0){
let checked = false;
this.cart.forEach((item)=>{
if(item.goods_id == that.gid && item.attr_id == that.attrId){
item.num = Number(item.num) + 1;
checked = true;
return false;
}
});
if(!checked){
this.cart.push({
goods_id:that.gid,
goods_title:that.info.title,
pic:that.info.pic,
attr_id:that.attrId,
price:that.attrPrice,
attr_title:that.attrTitle,
num:that.num,
});
}
}else{
this.cart.push({
goods_id:that.gid,
goods_title:that.info.title,
pic:that.info.pic,
attr_id:that.attrId,
price:that.attrPrice,
attr_title:that.attrTitle,
num:that.num,
});
}
console.log(this.cart);
this.closePop();
this.countPrice();
},
countPrice(){
let that = this;
this.amount = 0;
this.cartNum = 0;
if(this.cart.length > 0){
this.cart.forEach((item)=>{
that.amount += (Number(item.price) * Number(item.num));
that.cartNum += Number(item.num);
});
}
},
confirmOrder() {
let that = this;
if(!this.fromData.name){
this.$func.showToast('请输入联系人姓名');
this.userPop = true;
return false;
}
if(!this.fromData.phone){
this.$func.showToast('请输入联系人手机号码');
this.userPop = true;
return false;
}
if(!this.fromData.address){
this.$func.showToast('请输入上门地址');
this.userPop = true;
return false;
}
if(!this.fromData.house_number){
this.$func.showToast('请输入楼号门牌');
this.userPop = true;
return false;
}
if(!this.cart.length){
this.$func.showToast('请选择商品');
return false;
}
this.fromData.goods = JSON.stringify(this.cart);
this.fromData.type = this.type;
this.$func.confirm('确认提交订单？','提示',()=>{
that.$func.startLoading()
this.$api.confirmOrder(this.fromData).then((res)=>{
if(res){
if(res.data.pay_status > 0){
WeixinJSBridge.invoke(
'getBrandWCPayRequest', res.data.payment,
function(res){
that.$func.endLoading()
if(res.err_msg == "get_brand_wcpay_request:ok" ){
that.$func.showToast('支付成功');
setTimeout(()=>{
window.location.reload();
},300);
}else{
that.$func.showToast('已取消支付');
}
that.closePop();
}
);
}else{
that.$func.showToast('下单成功');
setTimeout(()=>{
window.location.reload();
},300);
}
}
})
})
},
initData(){
this.fromData.name = '';
this.fromData.phone = '';
this.fromData.address = '';
this.fromData.house_number = '';
this.fromData.remark = '';
this.fromData.goods = '';
this.cart = [];
},
position(){
let that = this;
wx.getLocation({
type: 'gcj02',
success: function (res) {
console.log('getLocation',res);
that.$router.push({name:'maps',params:{latitude:res.latitude,longitude:res.longitude}})
}
});
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false, //调试阶段建议开启
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"getLocation",
]
});
}
})
},
},
}



// WEBPACK FOOTER //
// ./src/pages/createOrder.vue